module.exports = __webpack_public_path__ + "static/media/Horace Slughorn 1.8b2228a2.jpg";